export default "__VITE_ASSET__BWPnxT3v__"